export const SET_ROBOT = 'setRobot';
export const SET_ROBOT_LIST = 'setRobotList';
export const SET_PRIVILEGED_ENTERPRISES = 'setPrivilegedEnterprise';
export const SET_ENTERPRISE = 'setEnterprise';
export const SET_PRIVILEGE_LIST = 'setPrivilegeList';
export const SET_PAGES = 'setPageInfos';
export const SET_CUR_PAGE = 'setCurrentPage';
export const SET_USER = 'setUser';
export const SET_USER_ROLE = 'setUserRole';
export const SET_USER_ROLE_MAP = 'setUserRoleMap';
export const TOGGLE_PAGE_CATEGORY = 'toggleCategory';

export const OPEN_CHAT_TEST = 'openChatTest';
export const CLOSE_CHAT_TEST = 'closeChatTest';

export const SET_USER_INFO = 'setUserInfo';
export const SHOW_USER_PREFERENCE = 'showUserPreference';
export const HIDE_USER_PREFERENCE = 'hideUserPreference';

export const SET_LANGUAGE = 'setLanguage';
export const SET_ENV = 'setENV';
export const SET_UI_MODULES = 'setUIModules';



// WEBPACK FOOTER //
// ./src/store/mutations_type.js